import { render, staticRenderFns } from "./FormLoading.vue?vue&type=template&id=06c6cb9a&scoped=true&"
var script = {}
import style0 from "./FormLoading.vue?vue&type=style&index=0&id=06c6cb9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c6cb9a",
  null
  
)

export default component.exports